// extracted by mini-css-extract-plugin
module.exports = {"link":"CreatePoButton_link__1fSml","icon":"CreatePoButton_icon__iV-gB","text":"CreatePoButton_text__2yj9s"};